angular.module('zc').component('zcDashboardDeliveryChart', {
  templateUrl: '/templates/projects.dashboard/delivery_chart.html',
  bindings: {
    project: '<',
    chart: '<',
  },
  controller: zcDashboardDeliveryChartController
});

zcDashboardDeliveryChartController.$inject = [
  '$scope',
  '$translate',
  '$window',
  'ChartV2',
  'lineChartV2Config'
];

function zcDashboardDeliveryChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    const deliveryCounts = [];
    const deliveryCountRatios = [];

    _.each(vm.project.dailyStats, stat => {
      const startAtUnixTime = moment(stat.start_at).valueOf();
      const deliveryCountRatio = stat.all_campaign.session_count / stat.all_access.session_count * 100;

      deliveryCounts.push([
        startAtUnixTime,
        stat.all_campaign.session_count,
      ]);

      deliveryCountRatios.push([
        startAtUnixTime,
        deliveryCountRatio,
      ]);
    });

    const chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: {
          formatter: function() {
            return `${$window.Highcharts.numberFormat(this.value, 0)} ${$translate.instant('projectsDashboard.deliveryChart.deliveryCounts')}`;
          }
        },
      }, {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: {
          formatter: function() {
            return `${$window.Highcharts.numberFormat(this.value, 2)} %`;
          }
        }
      }],
    });

    chart.addSeries({
      type: 'column',
      name: $translate.instant('projectsDashboard.deliveryChart.deliveryCounts'),
      data: deliveryCounts,
      tooltip: {
        valueDecimals: 0,
      },
      yAxis: 0,
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.deliveryChart.deliveryCountRatios'),
      data: deliveryCountRatios,
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      yAxis: 1,
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height,
      }
    });

  }
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.dashboard/delivery_chart.controller.js